'use client';

import { Card } from '@app/app/_components/Card/Card';
import { Heading } from '@app/app/_components/Heading/Heading';
import { Link } from '@app/app/_components/Link/Link';
import { Header } from '@app/app/_widgets/Header';
import { useTranslations } from 'next-intl';
import { useHomeNavigation } from '@app/app/_hooks/useHomeNavigation';

interface Props {
    error: Error & { digest?: string };
}

export default function Error({ error }: Props) {
    const t = useTranslations();
    const { homeLink, handleHomeClick, shouldReload } = useHomeNavigation();

    return (
        <>
            <Header />
            <div className="min-h-0 overflow-y-auto">
                <div className="flex min-h-full flex-col items-center justify-start py-6 md:px-8">
                    <Card className="items-center gap-8 p-8 md:min-w-dialog">
                        <Heading>{t('general.error')}</Heading>

                        {shouldReload ? (
                            <button onClick={handleHomeClick} className="text-sm font-medium text-primary-500">
                                {t('general.returnToHome')}
                            </button>
                        ) : (
                            <Link href={homeLink}>{t('general.returnToHome')}</Link>
                        )}
                    </Card>

                    {process.env.NODE_ENV === 'development' && (
                        <Card className="mt-8 bg-red-200 p-8">
                            <div>{error.message}</div>
                            <pre>{error.stack}</pre>
                        </Card>
                    )}
                </div>
            </div>
        </>
    );
}
